import React from 'react';

interface ErrorScreenProps {
  errorMessage: string;
  onReconnect: () => void;
}

const ErrorScreen: React.FC<ErrorScreenProps> = ({ errorMessage, onReconnect }) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 animate-[fadeIn_0.3s_ease-in]">
      <div className="glassmorphic rounded-3xl p-8 max-w-md w-full shadow-2xl text-center">
        <div className="text-6xl mb-4">😕</div>
        <h1 className="text-4xl font-bold bg-gradient-to-r from-quiz-purple via-quiz-pink to-quiz-orange bg-clip-text text-transparent mb-4">
          QuizCrunch
        </h1>
        <h2 className="text-2xl font-bold text-white mb-4">Oops! Connection Lost</h2>
        <p className="text-white/80 mb-6">{errorMessage || 'Unable to connect to game server'}</p>
        <button
          onClick={onReconnect}
          className="w-full py-4 text-xl font-bold text-white bg-gradient-to-r from-quiz-purple to-quiz-pink rounded-2xl hover:from-quiz-pink hover:to-quiz-orange transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl border-3 border-white/50"
        >
          🔄 Try Again
        </button>
      </div>
    </div>
  );
};

export default ErrorScreen;